$(document).ready(function() {

  // Image Unveil
  $("img").unveil();

  // Owl Slider Stuff
  var mainowl    = $(".main");
  mainowl.owlCarousel({

    navigation : true, // Show next and prev buttons
    slideSpeed : 500,
    paginationSpeed : 500,
    singleItem: true,
  	callbacks:true,
    autoPlay: false,
    stopOnHover: true,
    navigationText: [
      "<i class='fa fa-chevron-left fa-2x'></i>",
      "<i class='fa fa-chevron-right fa-2x'></i>"
    ]

    // "singleItem:true" is a shortcut for:
    // items : 1, 
    // itemsDesktop : false,
    // itemsDesktopSmall : false,
    // itemsTablet: false,
    // itemsMobile : false
  });

        



});

function resizeProductSize() {
  var maxHeight = 0;
  
  $(".container .sameheight").each(function() {
     var tempHeight = $(this).height();
     if ( maxHeight < tempHeight )
       maxHeight = tempHeight;
  });

  console.log('Max height ' + maxHeight);

  $(".container .sameheight").each(function() {
    $(this).css('min-height', maxHeight );
  });
}

$(document).ready(function() {
    resizeProductSize();
	$(".container .sameheight img").load(function() {
      resizeProductSize();
	});
});

$(window).resize(function() {
    resizeProductSize();
});
